import { render, staticRenderFns } from "./settings-organization-branded-link-shortener-add-host-dialog.vue?vue&type=template&id=dd021426&scoped=true&"
import script from "./settings-organization-branded-link-shortener-add-host-dialog.vue?vue&type=script&lang=js&"
export * from "./settings-organization-branded-link-shortener-add-host-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd021426",
  null
  
)

export default component.exports